<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KsoOQ1/tc-custom/9781439618936.jpg?1700065813332" alt="This image is the cover for the book French Lick and West Baden Springs, Postcard History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">French Lick and West Baden Springs, Postcard History
      </h1>
      <p class="bookDescription body article font2">
        <p>During the heyday of spas, two luxurious hotels, owned by flamboyant competing visionaries, attracted the rich and famous to southern Indiana. Hotel guests came from throughout the United States in search of cures and pleasure. Among the many noted celebrities visiting the French Lick Springs and West Baden Springs Hotels were Bob Hope, Bing Crosby, Al Capone, Joe Lewis, and professional golfer Walter Hagen, and the West Baden Springs Hotel was known as the �Eighth Wonder of the World.� After years of neglect, the two hotels have been restored to their original splendor. Legalization of gambling and the building of a �riverboat� casino between the hotels have lured pleasureseekers to celebrate modernday opulence and recreation.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        John Martin Smith
      </h2>
      
      <p class="authorDescription body article">John Martin Smith, a former president of the Indiana Historical Society, has been active in many historical endeavors. He is the author of several books, including Kendallville and Noble County, Angola and Steuben County, DeKalb County, Allen County, and Auburn: The Classic City.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?130cc6db